module.exports = __webpack_public_path__ + "img/vc4.bfa5d7fb.png";